/* PB Liquids Ingredients — de coverflow van de blikjes en de pop-up erachter.

   Vier dingen, allemaal om een rij die zelf al scrolt (scroll-snap in
   assets/pb-liquids-ingredients.css):

   1. HET KRIMPEN. Elke kaart krijgt per frame een schaal uit hoe ver haar
      midden van het midden van de baan staat: op het midden 1, één plek
      verder de zijschaal uit de stylesheet (0,713 op het artboard), twee
      plekken verder de verre schaal (0,62). De kaart in het midden ligt bovenop
      (z-index volgt de schaal). Dat is de --pbig-s die de stylesheet in de
      transform gebruikt; zonder JS staat hij op de server-gezette is-active.

   2. HET RONDLOPEN. Met de instelling aan zet dit script een kopie van alle
      kaarten vóór en ná de echte (drie sets), begint in de middelste set en
      springt — zodra de rij stilstaat in een kopie — precies één set terug of
      vooruit. Elke set ziet er hetzelfde uit, dus de sprong is onzichtbaar.
      Alles wat "een kaart" is rekent daarna met de echte index (modulo).

   3. DE BOLLETJES, net als bij pop stars: het bolletje van de kaart in het
      midden staat aan, een tik op een bolletje schuift ernaartoe — naar de
      dichtstbijzijnde kopie van die kaart, zodat het nooit een hele rij terug
      hoeft.

   4. DE POP-UP. Een tik op een kaart schuift haar naar het midden en opent de
      <dialog> van de sectie met wat er in de <template> van die kaart staat:
      bovenschrift, naam, foto en de ingrediënten. showModal() regelt de
      focusval, Escape en de achtergrond; dit script zet de pagina op slot
      zolang hij open is en geeft de focus daarna terug aan de kaart. Zodra de
      foto er is leest het de kleur aan de rand waar de tekst begint en geeft
      die aan het hele blad, zodat foto en vlak in elkaar overlopen. */
(function () {
  if (window.PBLiquidsIngredients) {
    window.PBLiquidsIngredients.init(document);
    return;
  }

  var controllers = new WeakMap();
  var LOCK_CLASS = 'pb-liquids-ingredients-open';
  var SETTLE_DELAY = 140;

  function findSections(root) {
    var list = [];
    if (root.matches && root.matches('[data-pbig-section]')) list.push(root);
    if (root.querySelectorAll) {
      list = list.concat(Array.prototype.slice.call(root.querySelectorAll('[data-pbig-section]')));
    }
    return list;
  }

  function readNumber(el, name, fallback) {
    var raw = window.getComputedStyle(el).getPropertyValue(name);
    var value = parseFloat(raw);
    return isNaN(value) ? fallback : value;
  }

  function stillMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* De gemiddelde kleur van een strook van de foto, als hex. Leest de rand die
     tegen de tekst aan ligt: onder de foto als de tekst eronder staat (het
     blad op een telefoon), rechts ervan als de tekst ernaast staat (het vak op
     desktop). De strook is de laatste 2% van wat er van de foto te zien is —
     `cover` snijdt af, dus eerst uitrekenen welk stuk zichtbaar is. Geeft null
     als de browser de foto niet wil laten lezen (geen CORS). */
  function tint(img, box, edge) {
    try {
      var iw = img.naturalWidth;
      var ih = img.naturalHeight;
      if (!iw || !ih || !box.width || !box.height) return null;

      var scale = Math.max(box.width / iw, box.height / ih);
      var visibleW = box.width / scale;
      var visibleH = box.height / scale;
      var left = (iw - visibleW) / 2;
      var top = (ih - visibleH) / 2;

      var sx, sy, sw, sh;
      if (edge === 'right') {
        sw = Math.max(2, Math.round(visibleW * 0.02));
        sx = Math.round(left + visibleW - sw);
        sy = Math.round(top);
        sh = Math.round(visibleH);
      } else {
        sh = Math.max(2, Math.round(visibleH * 0.02));
        sy = Math.round(top + visibleH - sh);
        sx = Math.round(left);
        sw = Math.round(visibleW);
      }

      var canvas = document.createElement('canvas');
      canvas.width = 1;
      canvas.height = 1;
      var ctx = canvas.getContext('2d');
      if (!ctx) return null;
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, 1, 1);
      var p = ctx.getImageData(0, 0, 1, 1).data;
      if (p[3] < 250) return null;

      return (
        '#' +
        [p[0], p[1], p[2]]
          .map(function (v) {
            return ('0' + v.toString(16)).slice(-2);
          })
          .join('')
      );
    } catch (error) {
      return null;
    }
  }

  function createController(section) {
    var slider = section.querySelector('[data-pbig-slider]');
    var track = section.querySelector('[data-pbig-track]');
    var originals = Array.prototype.slice.call(section.querySelectorAll('[data-pbig-slide]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-pbig-dot]'));
    var dialog = section.querySelector('[data-pbig-dialog]');
    if (!slider || !track || !originals.length) return null;

    var count = originals.length;
    var loop = slider.hasAttribute('data-pbig-loop') && count > 1;
    var all = originals;
    var current = -1;
    var frame = 0;
    var settleTimer = 0;
    var opener = null;

    /* ---- de kopieën voor het rondlopen ---------------------------------- */

    function makeClone(slide) {
      var clone = slide.cloneNode(true);
      clone.classList.remove('is-active');
      clone.setAttribute('data-pbig-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      var button = clone.querySelector('[data-pbig-card]');
      if (button) button.setAttribute('tabindex', '-1');
      var detail = clone.querySelector('[data-pbig-detail]');
      if (detail) detail.parentNode.removeChild(detail);
      return clone;
    }

    if (loop) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.forEach(function (slide) {
        before.appendChild(makeClone(slide));
        after.appendChild(makeClone(slide));
      });
      track.insertBefore(before, originals[0]);
      track.appendChild(after);
      all = Array.prototype.slice.call(track.querySelectorAll('[data-pbig-slide]'));
    }

    function real(abs) {
      return ((abs % count) + count) % count;
    }

    /* Waar de plek met absolute index `abs` naartoe moet om in het midden te
       staan. */
    function offsetFor(abs) {
      var slide = all[abs];
      return slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2;
    }

    function pitch() {
      if (all.length > 1) return Math.max(1, all[1].offsetLeft - all[0].offsetLeft);
      return Math.max(1, all[0].offsetWidth);
    }

    /* De kopie van kaart `index` die het dichtst bij de huidige scrollstand
       staat: zo schuift de rij nooit een hele set ver. */
    function nearestInstance(index) {
      if (!loop) return index;
      var best = index + count;
      var shortest = Infinity;
      for (var k = 0; k < 3; k++) {
        var abs = index + k * count;
        var distance = Math.abs(offsetFor(abs) - track.scrollLeft);
        if (distance < shortest) {
          shortest = distance;
          best = abs;
        }
      }
      return best;
    }

    function mark(index) {
      if (index === current || index < 0 || index >= count) return;
      current = index;

      all.forEach(function (slide, abs) {
        slide.classList.toggle('is-active', real(abs) === index);
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    var nearestAbs = 0;

    function layout() {
      var side = readNumber(track, '--pbig-side-scale', 0.713);
      var far = readNumber(track, '--pbig-far-scale', 0.62);
      var middle = track.scrollLeft + track.clientWidth / 2;
      var step = pitch();
      var shortest = Infinity;

      all.forEach(function (slide, abs) {
        var distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - middle);
        var d = distance / step;
        var scale;

        /* Lineair van 1 naar de zijschaal over de eerste plek, dan door naar
           de verre schaal over de tweede, en daar blijft het. */
        if (d <= 1) scale = 1 - (1 - side) * d;
        else scale = Math.max(far, side - (side - far) * (d - 1));

        slide.style.setProperty('--pbig-s', scale.toFixed(4));
        slide.style.zIndex = String(Math.round(scale * 100));

        if (distance < shortest) {
          shortest = distance;
          nearestAbs = abs;
        }
      });

      mark(real(nearestAbs));
    }

    /* De rij staat stil. Zijn we in een kopie beland, dan één set terug (of
       vooruit), zonder animatie: de kopie en het origineel staan precies een
       set uit elkaar en zien er hetzelfde uit. */
    function settle() {
      settleTimer = 0;
      if (!loop) return;

      var step = pitch() * count;
      if (nearestAbs < count) {
        track.scrollLeft += step;
      } else if (nearestAbs >= 2 * count) {
        track.scrollLeft -= step;
      }
    }

    function onScroll() {
      if (!frame) {
        frame = window.requestAnimationFrame(function () {
          frame = 0;
          layout();
        });
      }
      if (settleTimer) window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settle, SETTLE_DELAY);
    }

    function goTo(index, instant) {
      if (index < 0 || index >= count) return;
      var abs = loop ? nearestInstance(index) : index;
      var left = offsetFor(abs);

      if (track.scrollTo) {
        track.scrollTo({ left: left, behavior: instant || stillMotion() ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left;
      }
      mark(index);
    }

    /* Bij een andere vensterbreedte verschuiven de plekken; de kaart die in
       het midden stond, moet daar blijven. Zonder animatie, want dit is geen
       beweging van de bezoeker. */
    function onResize() {
      if (current >= 0) goTo(current, true);
      onScroll();
    }

    /* ---- de pop-up ---------------------------------------------------- */

    var image = dialog && dialog.querySelector('[data-pbig-dialog-image]');
    var media = dialog && dialog.querySelector('.pb-liquids-ingredients__media');
    var body = dialog && dialog.querySelector('.pb-liquids-ingredients__body');
    var eyebrow = dialog && dialog.querySelector('[data-pbig-dialog-eyebrow]');
    var title = dialog && dialog.querySelector('[data-pbig-dialog-title]');
    var list = dialog && dialog.querySelector('[data-pbig-dialog-list]');
    var pendingSrc = '';

    function paint(color) {
      if (dialog) dialog.style.setProperty('--pbig-popup-background', color);
    }

    /* De kleur van de foto overnemen, zodra hij er is. Alleen als het nog om
       dezelfde foto gaat: bij snel doorklikken kan een eerdere nog laden. */
    function onImageLoad() {
      if (!image || image.currentSrc.indexOf(pendingSrc) < 0 && image.src !== pendingSrc) return;
      var mediaBox = media ? media.getBoundingClientRect() : image.getBoundingClientRect();
      var bodyBox = body ? body.getBoundingClientRect() : null;
      var edge = bodyBox && bodyBox.top >= mediaBox.bottom - 1 ? 'bottom' : 'right';
      var color = tint(image, mediaBox, edge);
      if (color) paint(color);
    }

    function fill(slide) {
      var detail = slide.querySelector('[data-pbig-detail]');
      if (!detail) return false;

      paint(detail.getAttribute('data-pbig-background') || '');

      if (eyebrow) {
        eyebrow.textContent = detail.getAttribute('data-pbig-eyebrow') || '';
        eyebrow.hidden = !eyebrow.textContent;
      }
      if (title) title.textContent = detail.getAttribute('data-pbig-title') || '';

      if (image) {
        var src = detail.getAttribute('data-pbig-image');
        pendingSrc = src || '';
        if (src) {
          image.hidden = false;
          image.alt = detail.getAttribute('data-pbig-image-alt') || '';
          if (image.src === src && image.complete && image.naturalWidth) {
            onImageLoad();
          } else {
            image.src = src;
          }
        } else {
          image.removeAttribute('src');
          image.alt = '';
          image.hidden = true;
        }
      }

      if (list) {
        list.innerHTML = '';
        list.appendChild(detail.content.cloneNode(true));
      }
      return true;
    }

    function open(index) {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var slide = originals[index];
      if (!slide || !fill(slide)) return;

      opener = slide.querySelector('[data-pbig-card]');
      document.documentElement.classList.add(LOCK_CLASS);
      dialog.showModal();

      /* Bovenaan beginnen, ook als de vorige pop-up was doorgescrold. */
      dialog.scrollTop = 0;
      var sheet = dialog.querySelector('.pb-liquids-ingredients__sheet');
      if (sheet) sheet.scrollTop = 0;

      /* De foto staat nu pas in beeld; als hij al geladen was, nu meten. */
      if (image && image.complete && image.naturalWidth) onImageLoad();
    }

    function onClose() {
      document.documentElement.classList.remove(LOCK_CLASS);
      if (opener && typeof opener.focus === 'function') {
        /* Terug naar de kaart, maar zonder de focusring: dit is geen
           toetsenbord. De ring komt terug bij de eerste toetsaanslag. */
        opener.setAttribute('data-pbig-quiet', '');
        opener.focus({ preventScroll: true });
      }
      opener = null;
    }

    function onKeydown() {
      var quiet = section.querySelectorAll('[data-pbig-quiet]');
      Array.prototype.forEach.call(quiet, function (el) {
        el.removeAttribute('data-pbig-quiet');
      });
    }

    function onDialogClick(event) {
      /* Een klik op de achtergrond is een klik op de <dialog> zelf: alles in
         het blad heeft het blad als voorouder. */
      if (event.target === dialog) dialog.close();
    }

    function onCloseClick() {
      dialog.close();
    }

    /* ---- de knoppen ---------------------------------------------------- */

    function onCardClick(event) {
      var slide = event.currentTarget.closest('[data-pbig-slide]');
      var abs = all.indexOf(slide);
      if (abs < 0) return;
      var index = real(abs);

      if (index !== current || abs !== nearestAbs) goTo(index);
      open(index);
    }

    function onDotClick(event) {
      goTo(dots.indexOf(event.currentTarget));
    }

    var cards = all.map(function (slide) {
      return slide.querySelector('[data-pbig-card]');
    });

    cards.forEach(function (card) {
      if (card) card.addEventListener('click', onCardClick);
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', onDotClick);
    });
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    section.addEventListener('keydown', onKeydown);

    var closeButtons = [];
    if (dialog) {
      closeButtons = Array.prototype.slice.call(dialog.querySelectorAll('[data-pbig-close]'));
      closeButtons.forEach(function (button) {
        button.addEventListener('click', onCloseClick);
      });
      dialog.addEventListener('click', onDialogClick);
      dialog.addEventListener('close', onClose);
      if (image) image.addEventListener('load', onImageLoad);
    }

    /* Het script is er: vanaf nu volgt de schaal de scroll, zonder de
       overgang die de stylesheet zonder script gebruikt. */
    track.classList.add('is-live');

    /* Beginnen op de kaart uit de instelling — in de middelste set als de rij
       rondloopt — zonder animatie, en dan meten. */
    var start = parseInt(slider.getAttribute('data-pbig-start'), 10);
    if (isNaN(start) || start < 1) start = 1;
    start = Math.min(start, count) - 1;
    track.scrollLeft = offsetFor(loop ? start + count : start);
    mark(start);
    layout();

    return {
      destroy: function () {
        cards.forEach(function (card) {
          if (card) card.removeEventListener('click', onCardClick);
        });
        dots.forEach(function (dot) {
          dot.removeEventListener('click', onDotClick);
        });
        track.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
        section.removeEventListener('keydown', onKeydown);
        closeButtons.forEach(function (button) {
          button.removeEventListener('click', onCloseClick);
        });
        if (dialog) {
          dialog.removeEventListener('click', onDialogClick);
          dialog.removeEventListener('close', onClose);
          if (image) image.removeEventListener('load', onImageLoad);
          if (dialog.open) dialog.close();
        }
        if (frame) window.cancelAnimationFrame(frame);
        if (settleTimer) window.clearTimeout(settleTimer);
        Array.prototype.forEach.call(track.querySelectorAll('[data-pbig-clone]'), function (clone) {
          clone.parentNode.removeChild(clone);
        });
        track.classList.remove('is-live');
        controllers.delete(section);
      },
      selectSlide: function (slide) {
        var index = originals.indexOf(slide);
        if (index >= 0) goTo(index);
      },
    };
  }

  function init(root) {
    findSections(root).forEach(function (section) {
      if (controllers.has(section)) return;
      var controller = createController(section);
      if (controller) controllers.set(section, controller);
    });
  }

  function destroy(root) {
    findSections(root).forEach(function (section) {
      var controller = controllers.get(section);
      if (controller) controller.destroy();
    });
  }

  window.PBLiquidsIngredients = { init: init, destroy: destroy };

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  /* In de theme-editor schuift de rij naar het blok dat je aanklikt. */
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest ? event.target.closest('[data-pbig-slide]') : null;
    var section = slide && slide.closest('[data-pbig-section]');
    var controller = section && controllers.get(section);
    if (controller) controller.selectSlide(slide);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }
})();
